import { render, staticRenderFns } from "./google-oauth2.button.vue?vue&type=template&id=54415c8a&"
import script from "./google-oauth2.button.vue?vue&type=script&lang=ts&"
export * from "./google-oauth2.button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports